import React, { useState, useEffect } from 'react';
import { Box, Alert, Typography, Button, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShareIcon from '@mui/icons-material/Share';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';

// Detects if device is on iOS
const isIOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

// Detects if device is in standalone mode
const isInStandaloneMode = () => 
  window.matchMedia('(display-mode: standalone)').matches || 
  (window.navigator as any).standalone === true;

const PWAInstallPrompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  
  useEffect(() => {
    // Only show the install prompt on iOS devices that are not in standalone mode
    if (isIOS() && !isInStandaloneMode()) {
      // Don't show immediately - wait 3 seconds
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  // Hide the prompt and store in session storage so it doesn't appear again
  const handleDismiss = () => {
    setShowPrompt(false);
    sessionStorage.setItem('pwaPromptDismissed', 'true');
  };
  
  if (!showPrompt) return null;
  
  return (
    <Collapse in={showPrompt}>
      <Alert 
        severity="info"
        icon={<AddToHomeScreenIcon />}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleDismiss}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ 
          mb: 2, 
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          boxShadow: 3,
          borderRadius: 0
        }}
      >
        <Typography variant="body1" sx={{ mb: 1 }}>
          Install this app on your iPad for a better experience with full-sized keyboard.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ mr: 1 }}>
            1. Tap <ShareIcon sx={{ verticalAlign: 'middle', fontSize: '1.1rem' }} />
          </Box>
          <Box>
            2. Scroll down and tap <strong>Add to Home Screen</strong>
          </Box>
        </Box>
      </Alert>
    </Collapse>
  );
};

export default PWAInstallPrompt; 